var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"47c2049089361e7a3eb6ba5eb261ecf57a77d729"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["docupet-app-order@docupet"]={id:"47c2049089361e7a3eb6ba5eb261ecf57a77d729"};
      